import { useMemo } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Legend,
  Line,
  LineChart,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const CHART_BG = "#0A0A0A";
const COLORS = ["#FF9800", "#00E5FF", "#FF5722", "#F4E04D", "#B388FF"];

const tooltipStyle = {
  backgroundColor: "#121212",
  border: "1px solid #27272A",
  borderRadius: 0,
  fontFamily: "JetBrains Mono",
  fontSize: 12,
  color: "white",
};

export function HourlyChart({ data }) {
  return (
    <div className="border border-white/10 bg-[#121212] p-4">
      <p className="label-micro mb-3">VIAJES POR HORA</p>
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={data} margin={{ left: 0, right: 12, top: 8, bottom: 0 }}>
          <CartesianGrid stroke="#1A1A1A" strokeDasharray="2 4" />
          <XAxis dataKey="hour" stroke="#6B7280" tick={{ fontFamily: "JetBrains Mono", fontSize: 10 }} />
          <YAxis stroke="#6B7280" tick={{ fontFamily: "JetBrains Mono", fontSize: 10 }} width={50} />
          <Tooltip contentStyle={tooltipStyle} cursor={{ stroke: "#FF9800", strokeOpacity: 0.3 }} />
          <Line
            type="monotone"
            dataKey="trips"
            stroke="#FF9800"
            strokeWidth={2}
            dot={{ r: 2, fill: "#00E5FF", stroke: "#00E5FF" }}
            activeDot={{ r: 4 }}
            name="Viajes"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export function DistanceChart({ data }) {
  return (
    <div className="border border-white/10 bg-[#121212] p-4">
      <p className="label-micro mb-3">DISTRIBUCIÓN POR DISTANCIA (KM)</p>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={data} margin={{ left: 0, right: 12, top: 8, bottom: 0 }}>
          <CartesianGrid stroke="#1A1A1A" strokeDasharray="2 4" />
          <XAxis dataKey="band" stroke="#6B7280" tick={{ fontFamily: "JetBrains Mono", fontSize: 10 }} />
          <YAxis stroke="#6B7280" tick={{ fontFamily: "JetBrains Mono", fontSize: 10 }} width={60} />
          <Tooltip contentStyle={tooltipStyle} cursor={{ fill: "rgba(255,152,0,0.06)" }} />
          <Bar dataKey="trips" fill="#00E5FF" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function PurposeChart({ data }) {
  const display = useMemo(() => data.filter((d) => d.trips > 0), [data]);
  return (
    <div className="border border-white/10 bg-[#121212] p-4">
      <p className="label-micro mb-3">POR MOTIVO</p>
      <ResponsiveContainer width="100%" height={220}>
        <PieChart>
          <Pie
            data={display}
            dataKey="trips"
            nameKey="purpose"
            innerRadius={50}
            outerRadius={85}
            stroke="#0A0A0A"
            strokeWidth={2}
          >
            {display.map((_, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip contentStyle={tooltipStyle} />
          <Legend
            verticalAlign="bottom"
            wrapperStyle={{ fontFamily: "JetBrains Mono", fontSize: 10, color: "#9CA3AF" }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
